<template>

  <div class="Papers">
    <Animate ref="animate" />

    <!--数据展示-->
    <!--<el-table :data="tableData"
              stripe
              style="width: 100%"
              border
              highlight-current-row
              :header-cell-style="{'text-align':'center'}"
              @row-dblclick="rowDbclick"
    >
      <el-table-column type="index" :label="$t('messages.序号')" min-width="3.1" align='center' class="index"/>
      <el-table-column prop="year" :label="$t('messages.发布年份')" sortable min-width="5.5" align='center' class="year"/>
      <el-table-column prop="title" :label="$t('messages.题目')" min-width="30"/>
      <el-table-column prop="author" :label="$t('messages.作者')" min-width="24.8"/>
      <el-table-column prop="journal" :label="$t('messages.期刊')" min-width="22"/>
      &lt;!&ndash;<el-table-column prop="influFactor" :label="$t('messages.影响因子')" sortable min-width="6" align='center' class="influFactor"/>
      <el-table-column prop="partition" :label="$t('messages.分区')" min-width="5" align='center' class="partition"/>
      <el-table-column prop="link" :label="$t('messages.链接')" min-width="3.6">
        <template #default="scope">
          <el-link v-if="scope.row.link !== ''" :underline="false" icon="link" :href="scope.row.link"></el-link>
        </template>
      </el-table-column>&ndash;&gt;
    </el-table>-->

    <paper-year :data="articleData" class="articleData" />

    <!--分页-->
    <!--<el-pagination
            :currentPage="pagination.currentPage"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
    />-->
  </div>

</template>

<script>

  import {ref, reactive, onMounted, getCurrentInstance } from 'vue';
  import { useStore } from 'vuex'
  import {queryArticle} from '@/network/article'
  import Animate from "@/components/common/Animate";
  import PaperYear from "../childComps/PaperYear";

  import {ElMessage, ElMessageBox} from 'element-plus'

  export default {
    name: "Papers",
    components:{
      Animate,
      PaperYear,
    },
    setup() {

      const store = useStore()
      let instance = reactive({})
      instance = getCurrentInstance();
      //分页数据
      let pagination = reactive({
        currentPage: 1,
        pageSize: 20,
        total: 0,
      })

      //论文数据
      let pagerData = reactive([]);
      //表格数据
      let tableData = reactive([]);
      let articleData = reactive({})


      onMounted(() => {

        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })


      // methods
      queryArticle().then(res => {
        /*if (res.state === 200) {
          pagination.total = res.data.length;
          res.data.forEach(item => pagerData.push(item))
          //console.log('data:', pagerData[0])
          changeTableData(pagination.pageSize, pagination.currentPage);
        } else if (result.state === '50000'){
          router.push('/regLogin');
          ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
        }*/
        if (res.state === 200){
          let result = res.data
          //console.log('res.data', result)
          for (let i = 0; i < result.length; i++) {
            if (!articleData.hasOwnProperty(result[i].year + ' ')){
              articleData[result[i].year + ' '] = []
            }
            articleData[result[i].year + ' '].push(result[i])
          }//for
          //console.log(articleData)
        }//if
      })
      // 页面尺寸改变
      function handleSizeChange(newSize) {
        //console.log("页面尺寸改变了", newSize)
        //console.log(pagerData.length);
        pagination.pageSize = newSize;
        tableData.length = 0;
        changeTableData(newSize, pagination.currentPage)
      }

      // 页码变化
      function handleCurrentChange(newPage) {
        //console.log("页码发生变化", newPage)
        pagination.currentPage = newPage;
        tableData.length = 0;
        changeTableData(pagination.pageSize, newPage)
      }

      // 修改tableData的方法
      function changeTableData(newSize, newPage) {
        let from = (newPage - 1) * newSize;
        let to = 0;
        if ((from + newSize) < pagination.total) to = from + newSize;
        else to = pagination.total;
        for (let i = from; i < to; i++) {
          tableData.push(pagerData[i])
        }
      }
      //双击事件
      function rowDbclick(row, column, event) {
        if (row.link !== '')
          location.href = store.state.uploadFile + row.link
      }


      return {
        tableData, pagination, articleData,
        handleSizeChange, handleCurrentChange, rowDbclick,
      }
    }
  }
</script>

<style scoped lang="less">

  .el-table {
    margin-top: 50px;

    .el-icon:hover {
      color: #409EFF
    }

  }

  .articleData {
    padding: 40px 0 100px;
  }

  .el-pagination{
    display: flex;
    justify-content: center;
    padding: 40px 20px 100px 0;
  }

</style>